import { useRef, useState, useEffect } from 'react';
import { lightTheme } from '@sketch/global-styles';
import { useBreakpoint } from '@sketch/components';

/**
 *
 * useIsTitleSticky
 *
 * Quick hook to check if the Title container is sticky
 * so we can add custom styles
 *
 */
const useIsTitleSticky = () => {
    const ref = useRef(null);
    const [isTitleContainerSticky, setIsTitleContainerSticky] = useState(false);
    const isMobile = !useBreakpoint('xs');
    useEffect(() => {
        const element = ref === null || ref === void 0 ? void 0 : ref.current;
        if (isMobile && element) {
            const handleScroll = () => {
                setIsTitleContainerSticky(element.getBoundingClientRect().y <= lightTheme.header.height + 1);
            };
            window.addEventListener('scroll', handleScroll, { capture: true });
            return () => {
                window.removeEventListener('scroll', handleScroll, { capture: true });
            };
        }
    }, [isMobile]);
    return { ref, isTitleContainerSticky };
};

export { useIsTitleSticky };
